import React, { useState } from "react";

function Footer() {
  return <div>HI how are tou test weadoasp d;ljasjkd gaskljk,d a</div>;
}

export default Footer;
